import React from "react";
import '../index.css';

function Heroic(){
    return(
        <>
        <div className="heroic">
            <h1>HELLO, I'M <span>AMAN RAJ</span></h1>
            <p>Passionate about creating intuitive and engaging user experiences. Specialize in transforming ideas into beautifully crafted products.</p>
        </div>
        </>
    );
}

export default Heroic;